import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { ErrandActionMeasure } from './errand-action-measure';

export class ErrandAction extends ModelBase {
  constructor() {
    super();
    this.createdDate = new Date();
    this.actionMeasures = [];

    Object.defineProperties(this, {
      _createdDate: {
        writable: true,
        enumerable: false,
      },
    });
  }

  private _createdDate: Date;

  get createdDate(): Date {
    return this._createdDate;
  }
  set createdDate(date: Date) {
    this._createdDate = this.coerceDate(date);
  }
  createdBy: string;
  description: string;
  header: string;
  isPublic: boolean;
  isReadonly: boolean;
  publicHeader: string;
  publicDescription: string;
  chargedAmount: Money;
  priceListItemId: string;
  priceListQuantity: number;
  invoiceText: string;
  amountIncVat: Money;
  actionMeasures: ErrandActionMeasure[];
  invoiceItems: ErrandActionInvoiceItem[];

  get reportingsCount() {
    return this.actionMeasures ? this.actionMeasures.length : 0;
  }

  toJSON() {
    const json = Object.assign({}, this);
    json.createdDate = this.clearTimezoneOffset(this.createdDate);
    return json;
  }
}

export class ErrandActionInvoiceItem extends ModelBase {
  constructor() {
    super();
    this.priceListQuantity = 1;
  }
  description: string;
  createdDate: Date;
  priceListItemId: string;
  priceListItemUnit: string;
  priceListId: string;
  priceListQuantity: number;
  netAmount: Money;
  totalAmount: Money;
  createdBy: string;
  priceListName: string;
  priceListItemName: string;
}
